"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAudioLink = exports.appleMusicPattern = exports.spotifyPattern = void 0;
exports.spotifyPattern = /^(https?:\/\/)?(www\.)?(open\.spotify\.com\/|spotify:)([a-zA-Z0-9-]+\/)+([?]?.*)?$/;
exports.appleMusicPattern = /^(https?:\/\/)?(music\.)?apple\.com\//;
const buildQueryParams = (str) => (str.includes('?') ? str : `${str}?`);
const getAudioLinkSpotify = (match) => ({
    id: buildQueryParams(match[5]),
    type: match[4],
});
const getAudioLink = (url) => {
    if (!url) {
        return null;
    }
    const spotifyMatch = url.match(exports.spotifyPattern);
    if (spotifyMatch) {
        return {
            link: getAudioLinkSpotify(spotifyMatch),
            type: 'spotify',
        };
    }
    if (url.match(exports.appleMusicPattern)) {
        return {
            link: url.replace('music', 'embed.music'),
            type: 'apple_music',
        };
    }
    return null;
};
exports.getAudioLink = getAudioLink;
